// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file inventory/v1/category_events.proto (package inventory.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Category } from "./category_pb.js";
import { file_inventory_v1_category } from "./category_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/category_events.proto.
 */
export const file_inventory_v1_category_events: GenFile = /*@__PURE__*/
  fileDesc("CiJpbnZlbnRvcnkvdjEvY2F0ZWdvcnlfZXZlbnRzLnByb3RvEgxpbnZlbnRvcnkudjEivQEKDUNhdGVnb3J5RXZlbnQSNQoHY3JlYXRlZBgBIAEoCzIiLmludmVudG9yeS52MS5DYXRlZ29yeUNyZWF0ZWRFdmVudEgAEjUKB3VwZGF0ZWQYAiABKAsyIi5pbnZlbnRvcnkudjEuQ2F0ZWdvcnlVcGRhdGVkRXZlbnRIABI1CgdkZWxldGVkGAMgASgLMiIuaW52ZW50b3J5LnYxLkNhdGVnb3J5RGVsZXRlZEV2ZW50SABCBwoFZXZlbnQiQAoUQ2F0ZWdvcnlDcmVhdGVkRXZlbnQSKAoIY2F0ZWdvcnkYASABKAsyFi5pbnZlbnRvcnkudjEuQ2F0ZWdvcnkiewoUQ2F0ZWdvcnlVcGRhdGVkRXZlbnQSMQoRcHJldmlvdXNfY2F0ZWdvcnkYASABKAsyFi5pbnZlbnRvcnkudjEuQ2F0ZWdvcnkSMAoQdXBkYXRlZF9jYXRlZ29yeRgCIAEoCzIWLmludmVudG9yeS52MS5DYXRlZ29yeSJAChRDYXRlZ29yeURlbGV0ZWRFdmVudBIoCghjYXRlZ29yeRgBIAEoCzIWLmludmVudG9yeS52MS5DYXRlZ29yeUI3WjVwYWNrYWdlcy9iYWNrZW5kLW1vZHVsZS1pbnZlbnRvcnkvYXBpL3YxO2ludmVudG9yeV92MWIIZWRpdGlvbnNw6Ac", [file_inventory_v1_category]);

/**
 * @generated from message inventory.v1.CategoryEvent
 */
export type CategoryEvent = Message<"inventory.v1.CategoryEvent"> & {
  /**
   * @generated from oneof inventory.v1.CategoryEvent.event
   */
  event: {
    /**
     * @generated from field: inventory.v1.CategoryCreatedEvent created = 1;
     */
    value: CategoryCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: inventory.v1.CategoryUpdatedEvent updated = 2;
     */
    value: CategoryUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: inventory.v1.CategoryDeletedEvent deleted = 3;
     */
    value: CategoryDeletedEvent;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.CategoryEvent.
 * Use `create(CategoryEventSchema)` to create a new message.
 */
export const CategoryEventSchema: GenMessage<CategoryEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category_events, 0);

/**
 * @generated from message inventory.v1.CategoryCreatedEvent
 */
export type CategoryCreatedEvent = Message<"inventory.v1.CategoryCreatedEvent"> & {
  /**
   * @generated from field: inventory.v1.Category category = 1;
   */
  category?: Category;
};

/**
 * Describes the message inventory.v1.CategoryCreatedEvent.
 * Use `create(CategoryCreatedEventSchema)` to create a new message.
 */
export const CategoryCreatedEventSchema: GenMessage<CategoryCreatedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category_events, 1);

/**
 * @generated from message inventory.v1.CategoryUpdatedEvent
 */
export type CategoryUpdatedEvent = Message<"inventory.v1.CategoryUpdatedEvent"> & {
  /**
   * @generated from field: inventory.v1.Category previous_category = 1;
   */
  previousCategory?: Category;

  /**
   * @generated from field: inventory.v1.Category updated_category = 2;
   */
  updatedCategory?: Category;
};

/**
 * Describes the message inventory.v1.CategoryUpdatedEvent.
 * Use `create(CategoryUpdatedEventSchema)` to create a new message.
 */
export const CategoryUpdatedEventSchema: GenMessage<CategoryUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category_events, 2);

/**
 * @generated from message inventory.v1.CategoryDeletedEvent
 */
export type CategoryDeletedEvent = Message<"inventory.v1.CategoryDeletedEvent"> & {
  /**
   * @generated from field: inventory.v1.Category category = 1;
   */
  category?: Category;
};

/**
 * Describes the message inventory.v1.CategoryDeletedEvent.
 * Use `create(CategoryDeletedEventSchema)` to create a new message.
 */
export const CategoryDeletedEventSchema: GenMessage<CategoryDeletedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category_events, 3);

